module.exports = __webpack_public_path__ + "img/top_up.223a832.png";